import { render, staticRenderFns } from "./ImageDescription.vue?vue&type=template&id=3084dd4e"
import script from "./ImageDescription.vue?vue&type=script&lang=js"
export * from "./ImageDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports